import ColumnFilter from 'components/ui/Table/Filters/ColumnFilter'
import Table from 'components/ui/Table/Table'
import { useModal } from 'contexts/ModalContext'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ImSpinner9 } from 'react-icons/im'
import { LuSquarePen, LuTrash2 } from 'react-icons/lu'
import { Link } from 'wouter'

export default function UserCompGrid({ items, handleDelete }) {
  // Hook para gestionar el modal
  const { modal, openModal } = useModal()

  // Estado para almacenar los datos de la tabla
  const [getTableData, setTableData] = useState([])

  // Columnas:
  const columns = [
    {
      Header: 'Usuario', // Título de la columna
      accessor: 'User_UserName', // El campo del objeto para acceder a este dato
      Filter: ColumnFilter // Componente de filtro personalizado para esta columna
    },
    {
      Header: 'Nombre', // Título de la columna
      accessor: 'User_Name', // El campo del objeto para acceder a este dato
      Filter: ColumnFilter // Componente de filtro personalizado para esta columna
    },
    {
      Header: '', // Título de la columna
      accessor: 'User_Actions', // El campo del objeto para acceder a este dato
      disableSortBy: true, // Esta columna no tiene opción de ordenar
      // Función que renderiza las celdas de esta columna
      Cell: (value) => {
        return (
          <div className="float-right px-4 py-4 text-sm whitespace-nowrap">
            <div className="flex items-center gap-x-6">
              {/* Enlace para editar el usuario */}
              <Link
                href={`/users/${value?.cell?.row?.original?.User_Id}`}
                className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none"
              >
                <LuSquarePen size={20} />
              </Link>

              {/* Botón para eliminar el usuario */}
              <button
                type="button"
                className="text-gray-500 transition-colors duration-200 dark:hover:text-red-500 dark:text-gray-300 hover:text-red-500 focus:outline-none"
                onClick={() =>
                  // Abre el modal de confirmación de eliminación
                  openModal('DeleteModal', {
                    itemName: value?.cell?.row?.original?.User_Name,
                    itemId: value?.cell?.row?.original?.User_Id,
                    handleDelete
                  })
                }
              >
                <LuTrash2 size={20} />
              </button>
            </div>
          </div>
        )
      }
    }
  ]

  // Adaptar los datos para que coincidan con la estructura requerida por la tabla
  useEffect(() => {
    if (items) {
      const itemsData = []
      items?.forEach((item) => {
        itemsData.push({
          User_Id: item.id,
          User_UserName: item.username,
          User_Name: item.first_name + ' ' + item.last_name,
          User_Password: item.password,
          User_Email: item.email
        })
      })
      setTableData(itemsData)
    }
  }, [items]) // Este useEffect se ejecutará cada vez que 'items' cambie

  // Renderiza la tabla con los datos y las columnas definidas
  return getTableData?.length > 0 ||
    (getTableData?.length === 0 && items?.length === 0) ? (
    <Table
      data={getTableData}
      columns={columns}
      tableName={'Usuarios'}
      createNewItemURL={'/users/new'}
    />
  ) : (
    // Si los usuarios aún no están cargados, muestra un spinner de carga
    <div className="flex items-center content-center justify-center w-full h-full">
      <p
        className="flex flex-col-reverse items-center justify-center h-full font-bold dark:text-[#F5F5F5] text-gray-700"
        title="Cargando..."
      >
        <ImSpinner9 size={70} className="animate-spin" />
      </p>
    </div>
  )
}

// Define los tipos de las props que recibe el componente actual
UserCompGrid.propTypes = {
  items: PropTypes.array,
  handleDelete: PropTypes.func
}
